import { render } from "./AngWalangKwentangPodcast.vue?vue&type=template&id=7081e03b&scoped=true"
import script from "./AngWalangKwentangPodcast.vue?vue&type=script&lang=js"
export * from "./AngWalangKwentangPodcast.vue?vue&type=script&lang=js"

import "./AngWalangKwentangPodcast.vue?vue&type=style&index=0&id=7081e03b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7081e03b"]])

export default __exports__